import { render, staticRenderFns } from "./PublicSidebar.vue?vue&type=template&id=141db7ec&scoped=true&"
import script from "./PublicSidebar.vue?vue&type=script&lang=js&"
export * from "./PublicSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141db7ec",
  null
  
)

export default component.exports